<template>
	<van-swipe-cell class="swipe-cell-wrapper">
		<slot></slot>
		<template #right>
			<db-col width="auto">
				<slot name="swipe-slot-right" />
			</db-col>
		</template>
	</van-swipe-cell>
</template>

<script>
	import Vue from 'vue'
	import {SwipeCell} from 'vant'
	Vue.use(SwipeCell)
	
	export default {
		name: 'swipe-cell'
	}
</script>

<style lang="scss" type="text/scss">
	.swipe-cell-wrapper{
		.van-swipe-cell__wrapper{
			width: auto;
			
			.van-swipe-cell__right{
				width: auto;
			}
		}
	}
</style>
